import React from "react";

export default function ReacheableTimes({ times }) {
    const now = new Date();
    const today = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday",][now.getDay()];
    const from = times ? times[today]?.from : null;
    const till = times ? times[today]?.till : null;

    return (
        <>
            {till && from ?
                <>{window.Translator.trans("webstores_locus.time_formatter.opening_times.reachable").replace('{till}', till).replace('{from}', from)}</>
                :
                <>{window.Translator.trans("webstores_locus.time_formatter.opening_times.closed")}  </>
            }
        </>
    );
}
